module.exports = __webpack_public_path__ + "0001284a9b0aefac35230a1cab4e9cf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/404/404.png
// module id = 21
// module chunks = 0